import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    defaultMessage: 'Email Templates',
    id: 'pM89JV',
    description: 'page header',
  },
  pageSummary: {
    defaultMessage:
      'With our easy to customize email templates, you can make sure your customers get the info they need when their orders are shipped out.',
    id: 'h7Byt9',
    description: 'summarizes purpose of the page',
  },
  shipmentTab: {
    defaultMessage: 'Shipment Notification',
    id: 'I+jqoJ',
    description: 'tab header',
  },
  shipmentTabHeader: {
    defaultMessage: 'Shipment Notification Templates',
    id: 'yWJgoe',
    description: 'header of the tab content',
  },
  deliveryTab: {
    defaultMessage: 'Delivery Notification',
    id: '+LmGgP',
    description: 'tab header',
  },
  deliveryTabHeader: {
    defaultMessage: 'Delivery Notification Templates',
    id: '+cNbTp',
    description: 'tab header content',
  },
  standardTemplate: {
    defaultMessage: 'New Standard Template',
    id: 'TMfBKh',
    description: 'button text to create new standard email template',
  },
  blankTemplate: {
    defaultMessage: 'New Blank Template',
    id: 'kmCYTC',
    description: 'button text to create new blank email template',
  },
  gridColName: {
    defaultMessage: 'Name',
    id: 'E4K+gg',
    description: 'column name for the name of the template',
  },
  gridColCreated: {
    defaultMessage: 'Created',
    id: 'NJOjqr',
    description: 'column name for the created date of the template',
  },
  gridColLastModifiedDate: {
    defaultMessage: 'Last Modified Date',
    id: 'TwZ0re',
    description: 'column name for the last modified date column',
  },
  gridColLastModified: {
    defaultMessage: 'Last Modified',
    id: 'eTsB6f',
    description: 'column name for the user to last update the template',
  },
  gridColActions: {
    defaultMessage: 'Actions',
    id: '0fSHV6',
    description: 'column name for actions menu',
  },
  editAction: {
    defaultMessage: 'Edit',
    id: 'Spgn2d',
    description: 'option to click to edit an existing template',
  },
  copyAction: {
    defaultMessage: 'Copy',
    id: '55YADl',
    description: 'option to click to copy an existing template',
  },
  deleteAction: {
    defaultMessage: 'Delete',
    id: 'YNtIen',
    description: 'option to delete an existing template',
  },
  apiFetchError: {
    defaultMessage: 'An error occurred fetching the data.',
    id: 'm2Ujgs',
    description: 'error message to show if a request fails',
  },
  apiSaveError: {
    defaultMessage: 'An error occurred saving the data.',
    id: '4TLPrQ',
    description: 'error message to show if a request fails',
  },
  apiDeleteError: {
    defaultMessage: 'An error occurred deleting the data.',
    id: 'Oezqhq',
    description: 'error message to show if a request fails',
  },
  apiSendTestError: {
    defaultMessage: 'An error occurred sending the test email',
    id: 'V62GvW',
    description: 'error message if sending a test failed',
  },
  save: {
    defaultMessage: 'Save',
    id: 'LPMUuh',
    description: 'save pending changes',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'NtDw6l',
    description: 'cancel pending changes',
  },
  createModalHeader: {
    defaultMessage: 'New Email Template',
    id: '3M8dsc',
    description: 'new email template modal header',
  },
  updateModalHeader: {
    defaultMessage: 'Update Email Template',
    id: 'vc8Nsy',
    description: 'update email template modal header',
  },
  name: {
    defaultMessage: 'Name',
    id: 'THyb7d',
    description: 'label for the template name input',
  },
  subjectInput: {
    defaultMessage: 'Subject',
    id: 'HKSvKi',
    description: 'label for subject input',
  },
  sendTestEmail: {
    defaultMessage: 'Send Test Email',
    id: 'qAs39q',
    description: 'button text to launch send test email modal',
  },
  deleteConfirmationTitle: {
    defaultMessage: 'Delete Email Template',
    id: '0X7lSk',
    description: 'title for confirm delete modal',
  },
  askToDelete: {
    defaultMessage: 'Are you sure you want to permanently delete "{name}"? This cannot be undone.',
    id: 'iWjzHq',
    description: 'ask the user to confirm they want to delete',
  },
  pleaseNote: {
    defaultMessage: 'Please note the following:',
    id: '4jdubh',
    description: 'a list of items',
  },
  noteAutomation: {
    defaultMessage: 'Automation Rules applying this template will revert to Default Shipment Template',
    id: 'iIkm55',
    description: 'part of the list of things that happens after deleting',
  },
  noteStores: {
    defaultMessage: 'Stores using this template will revert to Default Shipment Template',
    id: 'mnq7Hs',
    description: 'part of the list of things that happens after deleting',
  },
  noteOrders: {
    defaultMessage: 'Orders using this template will not be affected',
    id: 'CMzjcX',
    description: 'part of the list of things that happens after deleting',
  },
  sendTestConfirmationTitle: {
    defaultMessage: 'Send Test Email',
    id: 'SzjgF8',
    description: 'title for modal asking seller to confirm send test email',
  },
  storeSelectionLabel: {
    defaultMessage: 'Use Branding From',
    id: 'LKR2Ak',
    description: 'label for store dropdown',
  },
  storeDropdownDefault: {
    defaultMessage: 'Select Store',
    id: 'RmJ7C9',
    description: 'dropdown text if no store is selected',
  },
  sendTo: {
    defaultMessage: 'Send To',
    id: 'ZhM/Ag',
    description: 'label for email address',
  },
  testEmailSent: {
    defaultMessage: 'Test Email Sent',
    id: '/eMGGB',
    description: 'modal title that shows after email sends',
  },
  usedBranding: {
    defaultMessage: 'Used Branding From',
    id: '3NF06C',
    description: 'label for what store was used for test email',
  },
  sentTo: {
    defaultMessage: 'Sent To',
    id: 'vQy3Om',
    description: 'label for what email address was used',
  },
  copySuffix: {
    defaultMessage: '{name} Copy',
    id: '9BSLXe',
    description: 'appended to template name when it is a copy',
  },
  configureNotAllowedHeader1: {
    defaultMessage: '<bold>Email templates cannot be edited until you’ve connected a carrier to your ShipStation account.</bold>',
    id: 'RFO7rc',
    description: 'shown to the user when they cannot save changes to templates',
  },
  configureNotAllowedHeader2: {
    defaultMessage: 'To complete set up, visit the <carriersLink>Carrier settings page</carriersLink>.',
    id: 'at4M+H',
    description: 'shown to the user when they cannot save changes to templates',
  },
  configureNotAllowedModal: {
    defaultMessage:
      '<bold>Saving is not enabled.</bold> Changes made to this template cannot be saved until you <carriersLink>add a Carrier.</carriersLink>',
    id: 'KljELO',
    description: 'shown to the user in the editor when they cannot save changes',
  },
});
